import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true, // crucial for cookie-based auth
  headers: { "Content-Type": "application/json" },
});

api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err?.response?.status === 401) {
      // Let the AuthContext handle redirect; do not auto-redirect here
    }
    return Promise.reject(err);
  }
);

export default api;
